export interface CriteriaWeightsTreeViewport {
  zoom: number;
  panX: number;
  panY: number;
}

export interface CriteriaWeightsTreePoint {
  x: number;
  y: number;
}

export const TREE_VIEWPORT_PADDING = 24;
export const TREE_ZOOM_STEP = 1.2;
export const MIN_TREE_ZOOM = 0.3;
export const MIN_FITTED_TREE_ZOOM = 0.6;
export const MAX_TREE_ZOOM = 2.5;

export function fitTreeViewport(
  contentWidth: number,
  availableWidth: number,
): CriteriaWeightsTreeViewport {
  const fittingZoom =
    availableWidth > 0 ? (availableWidth - 2 * TREE_VIEWPORT_PADDING) / contentWidth : 1;

  return {
    zoom: Math.min(Math.max(fittingZoom, MIN_FITTED_TREE_ZOOM), 1),
    panX: TREE_VIEWPORT_PADDING,
    panY: TREE_VIEWPORT_PADDING,
  };
}

export function zoomTreeViewport(
  viewport: CriteriaWeightsTreeViewport,
  focus: CriteriaWeightsTreePoint,
  factor: number,
): CriteriaWeightsTreeViewport {
  const zoom = Math.min(Math.max(viewport.zoom * factor, MIN_TREE_ZOOM), MAX_TREE_ZOOM);
  const appliedFactor = zoom / viewport.zoom;

  return {
    zoom,
    panX: focus.x - (focus.x - viewport.panX) * appliedFactor,
    panY: focus.y - (focus.y - viewport.panY) * appliedFactor,
  };
}

export function panTreeViewport(
  viewport: CriteriaWeightsTreeViewport,
  deltaX: number,
  deltaY: number,
): CriteriaWeightsTreeViewport {
  return {...viewport, panX: viewport.panX + deltaX, panY: viewport.panY + deltaY};
}
